import { LoadableRoute } from 'routes/utils/loadable';

export const DashboardContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "DashboardRoot" */ './Dashboard'),
});
